import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function invoices() {
    return {
        index,
        remove,
        get,
        save,
        invoiceDocument,
        voidInvoice,
        sendEmail,
        getBodyEmail
    };

    function index(options = {}) {
        const defaultValues = {
            limit: 25,
            page: 1,
            pattern: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`bill/search${params}`);
    }

    function get(invoiceId) {
        return axiosInstance.get(`bill/get?id=${invoiceId}`);
    }

    function save(payload) {
        if (payload.id) {
            return axiosInstance.patch('bill/update', payload);
        } else {
            return axiosInstance.post('bill/create', payload);
        }
    }

    function remove(invoiceId) {
        return axiosInstance.post(`package/deleteinvoice`, {
            invoiceid: invoiceId
        });
    }

    function invoiceDocument(payload) {
        if (payload) {
            return axiosInstance.post('bill/create-from-document', payload);
        }
    }

    function voidInvoice(id) {
        return axiosInstance.delete(`bill/void`, {
            data: {
                id: id
            }
        });
    }

    function sendEmail({ id, emails, body, subject }) {
        return axiosInstance.post(`bill/send-emails`, {
            id: id,
            emails: emails,
            body: body,
            subject: subject
        });
    }

    function getBodyEmail(tableClass) {
        return axiosInstance.get(`bill/get-body-email?id=${tableClass}`);
    }
}
